
import { mapMutations, mapGetters, mapActions } from 'vuex';
import vClickOutside from 'v-click-outside';

import MenuItems from '@/components/MenuItems';
import CompareProductItem from '~/components/header/CompareProductItem';
import HeaderMobile from '~/components/header/HeaderMobile';
import SearchForm from '~/components/header/SearchForm';
import FavoritesClearIcon from '@/components/svg/FavoritesClearIcon.vue';
import SearchFormEcom from '@/components/header/SearchFormEcom.vue';
import CompareIcon from '@/components/svg/CompareIcon.vue';
import CartIcon from '@/components/svg/CartIcon.vue';
import viewport from '~/mixins/viewport';

import header from '~/mixins/header';

export default {
    mixins: [header, viewport],
    watch: {
        $route() {
            this.setShowMenu(false);
            this.setShowMenuMobile(false);
        },
    },

    components: {
        SearchFormEcom,
        FavoritesClearIcon,
        SearchForm,
        HeaderMobile,
        MenuItems,
        CompareProductItem,
        CompareIcon,
        CartIcon,
    },

    data() {
        return {
            onScrollIs: false,
            fixedIs: false,
            scrollPos: 100,
        };
    },
    methods: {
        ...mapMutations({
            setShowMenu: 'setShowMenu',
            setShowMenuMobile: 'setShowMenuMobile',
            initFavoritesProducts: 'favorites/initFavProducts',
            initCompareProducts: 'compare/initCompareProducts',
        }),
        ...mapActions('cart', ['openCart']),
        toggleMenu() {
            this.setShowMenu(!this.showMenu);
        },
        openModalAuth() {
            this.$store.dispatch('auth/setIsOpen', true);
        },
        logout() {
            this.$store.dispatch('auth/logout');
        },
        externalClickMenu(event) {
            if (this.showMenu || (event.target.id !== 'menuBtn' && event.target.id !== 'imgMenuBtn')) {
                if (event.target.id !== 'menuBtn' && event.target.id !== 'imgMenuBtn') {
                    this.setShowMenu(false);
                }
            }
        },
        handleScroll(event) {
            this.fixedIs = false;
            if (window.scrollY > 100) {
                this.onScrollIs = true;
                if (window.scrollY < this.scrollPos) {
                    this.fixedIs = true;
                }
                this.scrollPos = window.scrollY;
            } else {
                this.onScrollIs = false;
            }
        },
        favoritesProducts() {
            if (process.client && localStorage?.getItem('favorites')) {
                this.initFavoritesProducts(JSON.parse(localStorage?.getItem('favorites')));
            } else {
                this.initFavoritesProducts([]);
            }
        },
        compareProducts() {
            if (process.client && localStorage?.getItem('compare')) {
                this.initCompareProducts(JSON.parse(localStorage?.getItem('compare')));
            } else {
                this.initCompareProducts([]);
            }
        },
    },

    computed: {
        ...mapGetters(['showMenu']),
        ...mapGetters({
            isOpen: 'auth/isOpen',
            isAuth: 'auth/isAuth',
            isNovaPorta: 'global/getIsNovaPorta',
            favoritesProductsLength: 'favorites/getProductsLength',
            compareProductsLength: 'compare/getCompareProductsLength',
            cartProductsLength: 'cart/getProductsLength',
            globalSettings: 'global/globalSettings',
            isVitrina: 'global/isVitrina',
            getCompareProducts: 'compare/getCompareProducts',
            getCompareCategory: 'compare/getCompareProducts',
            mainPhoneNumber: 'global/mainPhoneNumber',
        }),
        ...mapGetters('search', ['getModalShow']),
        currentLocaleName() {
            return this.$i18n.locales.filter(i => i.code === this.$i18n.locale)[0]?.name;
        },
    },
    mounted() {
        this.favoritesProducts();
        this.compareProducts();
    },
    created() {
        if (process.browser) {
            window.addEventListener('scroll', this.handleScroll);
        }
    },
    destroyed() {
        if (process.browser) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    },
};
